import {formatNumber} from '@/providers/fields'
import {apptokens as apptokens_fields} from '@/sections/apptokens/fields'

//CONTRACTS
export var billings_contracts;
billings_contracts = Object.assign({}, apptokens_fields, {
  billings_plans_id: {
    type: 'empty',
    required: false,
  },
  billings_cycles: {
    trans: 'billings:wizard.cycle',
    type: 'buttonselect',
    values: {
      monthly: 'billings:plans.per_month',
      annually: 'billings:plans.per_year',
    },
  },
  signed_tos_id: {
    trans: 'apptokens:fields.signed_tos_id',
    type: 'switch',
  },
});

//INVOICES
export const billings = {
  billing_status: 'billings:invoices.fields.status',
  invoice_number: 'billings:invoices.fields.invoice_number',
  invoice_date: {
    trans: 'billings:invoices.fields.invoice_date',
    format: 'date',
  },
  company_name: 'billings:invoices.fields.company_name',
  created_at: 'billings:fields.created_at',
  payment_type_name: 'billings:fields.payment_type',
  cost_final: {
    trans: 'billings:invoices.fields.amount',
    format: 'money',
    currency: item => item.currency,
  },
  cost_clean: {
    trans: 'billings:prices.subtotal',
    format: 'currency',
    currency: item => item.currency,
  },
  cost_tax: {
    trans: 'billings:prices.tax',
    format: 'currency',
    currency: item => item.currency,
  },
  currency: 'billings:invoices.fields.currency',
  invoice_download: 'Invoice Download',
};

//PLANS
export const billings_plans = {
  name: 'billings:name',
  prices_subscription_monthly: {
    trans: 'billings:prices_subscription_monthly',
    format: 'money',
  },
  prices_subscription_annually: {
    trans: 'billings:prices_subscription_annually',
    format: 'money',
  },

  cap_publish_contests: {
    trans: 'billings:cap_publish_contests',
    format: 'int',
  },
  cap_participations_contests: {
    trans: 'billings:cap_participations_contests',
    format: 'int',
  },
  credits: {
    trans: 'billings:credits',
    function: (item, el) => {
      if (Number(item.credits) === 0) {
        return el('span', {class: 'icon'}, ['∞']);
      } else {
        return el('span', [
          formatNumber(item.credits, 3),
          ' ',
          el('Icon', {props: {name: 'CR'}})
        ], ['∞']);
      }
    },
  },
  credits_price: {
    trans: 'billings:credits_price',
    format: 'money',
  },
  credits_per_request_default: {
    trans: 'billings:credits_per_request_default',
    format: 'currency',
    currency: (item, el) => el('Icon', {props: {name: 'CR'}}),
  },
  cap_images: {
    trans: 'billings:cap_images',
    format: 'int',
  },
  /*options_contests_publishing: {
    trans: 'billings:cap_images',
    format: 'tick',
    true_if_id: {2=>2,3=>3,4=>4),   //TEMP. Is this option available in billings_plans resource
  },*/
  options_locked_after_cap: {
    trans: 'billings:options_locked_after_cap',
    format: 'tick',
    invert: true,
  },
  /*cap_contests_contents_max_on_each_contest: {
    trans: 'billings:cap_contests_contents_max_on_each_contest',
    format: 'tick',
  },*/
  options_contests_visibility_filter: {
    trans: 'billings:options_contests_visibility_filter',
    format: 'tick',
  },
  /*options_contests_private_company: {
    trans: 'billings:options_contests_private_company',
    format: 'tick',
    true_if_id: {4=>4),   //TEMP. Is this option available in billings_plans resource
  },*/
  options_basic_support: {
    trans: 'billings:options_basic_support',
    format: 'tick',
  },
  options_email_support_24: {
    trans: 'billings:options_email_support_24',
    format: 'tick',
  },
  options_phone_support_24: {
    trans: 'billings:options_phone_support_24',
    format: 'tick',
  },
  options_tech_support: {
    trans: 'billings:options_tech_support',
    format: 'tick',
  },

};

//TRANSACTIONS
export const billings_transactions = {
  id: 'billings:transactions.fields.id',
  created_at: {
    trans: 'billings:transactions.fields.created_at',
    type: 'datetime',
  },
  type: 'billings:transactions.fields.type',
  description: 'billings:transactions.fields.type',
};


// WEBPACK FOOTER //
// ./src/sections/billings/fields.js